import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getAllFinacUsersAction, resetSession } from "../../../../redux/auth";
import {
  deleteRecruitmentTrackerAction,
  getRecruitmentModuleOpenPositionAction,
  getRecruitmentTrackerListAction,
  resetHrmsError,
  resetHrmsMessage,
  resetHrmsStatusCode,
  resetHrmsSuccess,
  resetRecruitmentTrackerList,
  resetRecruitmentTrackerStageCountList,
  resetRecruitmentTrackerTotalCount,
} from "../../../../redux/hrms";
import { RootState } from "../../../../redux/rootReducers";
import { SearchIcon } from "../../../Icon";
import {
  ConfirmationModal,
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
} from "../../../commons";
import {
  analyticsGrey,
  analyticsIcon,
  BulkUploadIcon,
  EmptyList,
  NewDownloadIcon,
} from "../../../../assets/images";
import InfiniteLoader from "../../../commons/InfiniteLoader/InfiniteLoader";
import ScrollToTop from "../../../commons/ScrollToTop";
import RecruitementTrackerTable from "../RecruitementTrackerTable";
import useDebounce from "../../../../customHooks/useDebounce";
import {
  DeleteOpenPositionPayloadType,
  DownloadRecruitmentTrackerPayloadType,
  FilterOffsetType,
  FilterTextType,
  FilterValueType,
  GetOpenPositionPayloadType,
  GetRecruitmentTrackerPayloadType,
  MultiSelectDataType,
  RecruitmentSortingType,
} from "../../../../commonTypes/hrmsTypes";
import RecruitementSorting from "../RecruitementSorting";
import toast from "react-hot-toast";
import { useMenuCheck } from "../../../../customHooks/useMenuCheck";
import RecuritmentModuleFilter from "../RecruitementFilter";
import { GetAllFinacUserPayloadType } from "../../../../commonTypes/authTypes";
import {
  getAllMasterDataBranchAction,
  getMasterDataBranchAction,
  resetBranchError,
  resetBranchFetching,
  resetBranchMessage,
  resetBranchSatusCode,
  resetMasterDataLisitng,
  setPersistApplicationInProgess,
} from "../../../../redux/masterData";
import { GetAllMasterDataBranchPayloadType } from "../../../../commonTypes/masterDataTypes";
import { formatDate } from "../../../../utils/commonFunctions";
import { PersistDataType } from "../../../../redux/masterData/masterTypes";
import RecruitmentTrackerStageCount from "./RecruitmentTrackerStageCount";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import FileSaver from "file-saver";
import { downloadApplicationInProgressExcelApi } from "../../../../apis/hrmsApis";
import { RecruitmentTrackerStageCountType } from "../../../../redux/hrms/hrmsTypes";
import { Link } from "react-router-dom";

type AppProps = {
  activeTab: any;
  history: any;
  token: string | null;
  success: number | null;
  fetching: boolean;
  finacUser: any;
  branchFetching: boolean;
  masterDataListing: [];
  masterDataBranchListTotal: string | number;
  branchMessage: string | null;
  error: string | null | undefined;
  message: string | null | undefined;
  statusCode: number | null;
  recruitmentTrackerList: any[];
  recruitmentTrackerTotalCount: number;
  persistApplicationInProgressList: PersistDataType;
  jobPositionFetching: boolean;
  openPoisitionList: any;
  openPositionTotalCount: number;
  dispatchResetSession: () => void;
  dispatchResetHrmsSuccess: () => void;
  dispatchResetHrmsMessage: () => void;
  dispatchResetHrmsError: () => void;
  dispatchResetHrmsStatusCode: () => void;
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
  dispatchResetRecruitmentTrackerList: () => void;
  dispatchGetRecruitmentTrackerListAction: (
    data: GetRecruitmentTrackerPayloadType
  ) => void;
  dispatchDeleteRecruitmentTrackerAction: (
    data: DeleteOpenPositionPayloadType
  ) => void;
  dispatchGetMasterDataBranch: (
    data: GetAllMasterDataBranchPayloadType
  ) => void;
  dispatchResetMasterDataListing: () => void;
  dispatchResetBranchStatusCode: () => void;
  dispatchResetBranchError: () => void;
  dispatchResetBranchMessage: () => void;
  dispatchResetBranchFetching: () => void;
  dispatchResetRecruitmentTrackerTotalCount: () => void;
  dispatchSetPersistApplicationInProgressData: (data: any) => void;
  dispatchGetRecruitmentModuleOpenPositionAction: (
    data: GetOpenPositionPayloadType
  ) => void;
  dispatchResetRecruitmentTrackerStageCountList: () => void;
  recruitmentTrackerStageCount: RecruitmentTrackerStageCountType[] | [];
};
const ApplicationInProgressList = ({
  activeTab,
  history,
  token,
  success,
  fetching,
  error,
  message,
  statusCode,
  finacUser,
  masterDataListing,
  branchFetching,
  branchMessage,
  recruitmentTrackerList,
  recruitmentTrackerTotalCount,
  masterDataBranchListTotal,
  persistApplicationInProgressList,
  jobPositionFetching,
  openPoisitionList,
  openPositionTotalCount,
  recruitmentTrackerStageCount,
  dispatchResetSession,
  dispatchResetHrmsSuccess,
  dispatchResetHrmsMessage,
  dispatchResetHrmsError,
  dispatchResetHrmsStatusCode,
  dispatchGetAllFinacUsersAction,
  dispatchResetRecruitmentTrackerList,
  dispatchGetRecruitmentTrackerListAction,
  dispatchDeleteRecruitmentTrackerAction,
  dispatchGetMasterDataBranch,
  dispatchResetRecruitmentTrackerTotalCount,
  dispatchSetPersistApplicationInProgressData,
  dispatchGetRecruitmentModuleOpenPositionAction,
  dispatchResetRecruitmentTrackerStageCountList,
}: AppProps) => {
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState<boolean>(false);
  const [finalJobPositionList, setFinalJobPositionList] = useState<any>([]);
  const persistMultiSelectData = history?.location?.state?.multiSelectData;
  const persistSortBy = history?.location?.state?.sortBy;
  const persistSearchTerm = history?.location?.state?.searchTerm;
  const [isPersist, setIsPersist] = useState(
    history?.location?.state && history?.location?.state?.isPersist
  );
  const [scrollHeights, setScrollHeights] = useState<any>({});
  const [deleteId, setDeleteId] = useState("");
  const [offset, setOffset] = useState<number>(
    !isPersist ? 0 : persistApplicationInProgressList?.offset
  );
  const [limit, setLimit] = useState<number>(20);
  const [data, setData] = useState<any[] | []>(
    !isPersist
      ? []
      : persistApplicationInProgressList?.data?.length > 0
      ? [...persistApplicationInProgressList?.data]
      : []
  );
  const [searchTerm, setSearchTerm] = useState<string>(
    persistSearchTerm ? persistSearchTerm : ""
  );
  const [toggleFilterModal, setToggleFilterModal] = useState(false);
  const [isApiCall, setIsApiCall] = useState<boolean>(false);
  const [toggle, setToggle] = useState<boolean>(false);
  const [branchFinalData, setBranchFinalData] = useState<any>([]);
  const [filterToggle, setFilterToggle] = useState<boolean>(false);
  const [filterStartDate, setFilterStartDate] = useState<string>(
    persistMultiSelectData?.filterStartDate
      ? persistMultiSelectData?.filterStartDate
      : ""
  );
  const [filterEndDate, setFilterEndDate] = useState<string>(
    persistMultiSelectData?.filterEndDate
      ? persistMultiSelectData?.filterEndDate
      : ""
  );
  const [finalUserList, setFinalUserList] = useState<any>([]);
  const [filterText, setFilterText] = useState<FilterTextType>({
    locationText: "",
    recuriterText: "",
    openPositionText: "",
  });
  const [filterOffset, setFilterOffset] = useState<FilterOffsetType>({
    locationOffset: 0,
    recuriterOffset: 0,
    openPositionOffset: 0,
  });
  const [filterValue, setFilterValue] = useState<FilterValueType>({
    location: persistMultiSelectData?.location?.value
      ? persistMultiSelectData?.location
      : { name: "", value: "" },
    recuriter: persistMultiSelectData?.recuriter?.value
      ? persistMultiSelectData?.recuriter
      : { name: "", value: "" },
    progress: persistMultiSelectData?.progress?.value
      ? persistMultiSelectData?.progress
      : { name: "", value: "" },
    experience: persistMultiSelectData?.experience
      ? persistMultiSelectData?.experience
      : null,
    gender: persistMultiSelectData?.gender
      ? persistMultiSelectData?.gender
      : null,
    openPosition: persistMultiSelectData?.openPosition?.value
      ? persistMultiSelectData?.openPosition
      : { name: "", value: "" },
  });
  const [multiSelectData, setMultiSelectData] = useState<MultiSelectDataType>(
    persistMultiSelectData
      ? persistMultiSelectData
      : {
          filterStartDate: "",
          filterEndDate: "",
          location: { name: "", value: "" },
          openPosition: { name: "", value: "" },
          recuriter: { name: "", value: "" },
          progress: { name: "", value: "" },
          gender: { name: "", value: "" },
          experience: null,
        }
  );
  const [sortBy, setSortBy] = useState<RecruitmentSortingType>(
    persistSortBy
      ? persistSortBy
      : {
          name: "",
          value: "",
          id: "",
          _id: "",
        }
  );
  const [isPieChartVisible, setIsPieChartVisible] = useState<boolean>(true);
  //====================User Management=============================
  const [isEditRecruitmentTrackerPresent, setIsEditRecruitmentTrackerPresent] =
    useMenuCheck();
  const [
    isDeleteRecruitmentTrackerPresent,
    setIsDeleteRecruitmentTrackerPresent,
  ] = useMenuCheck();
  const [
    isRecruitmentModuleStageCountPresent,
    setIsRecruitmentModuleStageCountPresent,
  ] = useMenuCheck();
  const [
    isIsApplicationInProgressDownloadPresent,
    setIsApplicationInProgressDownloadPresent,
  ] = useMenuCheck();
  const [isBulkUploadRecruitmentTrackerPresent, setIsBulkUploadRecruitmentTrackerPresent] = useMenuCheck();
  //=================================================================
  useEffect(() => {
    setIsBulkUploadRecruitmentTrackerPresent("Bulk Upload Recruitment Tracker", "menu");
    if (!isPersist) {
      window.scroll({
        top: 0,
        left: 0,
      });
      dispatchResetHrmsSuccess();
      dispatchResetHrmsError();
      dispatchResetHrmsMessage();
      dispatchResetRecruitmentTrackerList();
      dispatchResetRecruitmentTrackerTotalCount();
      dispatchResetHrmsStatusCode();
      dispatchResetRecruitmentTrackerStageCountList();
      setIsEditRecruitmentTrackerPresent("Edit Recruitment Tracker", "menu");
      setIsDeleteRecruitmentTrackerPresent("Delete recruitment ", "menu");
      setIsApplicationInProgressDownloadPresent(
        "Download Application In Progress List",
        "menu"
      );
    } else {
      window.scroll({
        top: persistApplicationInProgressList?.scrollTop,
        left: persistApplicationInProgressList?.scrollLeft,
      });
    }
  }, []);

  useEffect(() => {
    if (persistApplicationInProgressList?.data?.length > 0) {
      setIsApiCall(true);
      setScrollHeights({
        scrollLeft: persistApplicationInProgressList?.scrollLeft,
        scrollTop: persistApplicationInProgressList?.scrollTop,
      });
    }
  }, [persistApplicationInProgressList?.data]);

  useEffect(() => {
    if (!isPersist) {
      if (recruitmentTrackerList?.length === 0) {
        setData(recruitmentTrackerList);
      } else if (offset > 0 && recruitmentTrackerList?.length > 0) {
        setData((prv: any) => [...prv, ...recruitmentTrackerList]);
      } else {
        setData(recruitmentTrackerList);
      }
    }
  }, [recruitmentTrackerList]);

  useEffect(() => {
    const finalUserData = finacUser?.data?.map((user: any) => {
      return {
        value: user?.user_id,
        label: `${user?.first_name} ${user?.last_name}`,
        image: user?.profile_pic?.file_url,
      };
    });
    if (filterOffset?.recuriterOffset > 0 && finalUserList?.length) {
      setFinalUserList([...finalUserList, ...finalUserData]);
    } else {
      setFinalUserList(finalUserData);
    }
  }, [finacUser]);

  useEffect(() => {
    const finalBranchData = masterDataListing?.map((user: any) => {
      return {
        value: user?._id,
        label: user?.branch_name,
      };
    });
    if (filterOffset?.locationOffset > 0 && masterDataListing?.length) {
      setBranchFinalData([...branchFinalData, ...finalBranchData]);
    } else {
      setBranchFinalData(finalBranchData);
    }
  }, [masterDataListing]);

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: filterOffset?.locationOffset,
        limit: limit,
        search_term: filterText?.locationText,
      };
      if (filterOffset?.locationOffset <= +masterDataBranchListTotal) {
        dispatchGetMasterDataBranch(finalUserData);
      }
    }
  }, [filterOffset?.locationOffset]);

  const fetchNewBranchData = (search: string) => {
    const finalData = {
      token,
      offset: filterOffset?.locationOffset,
      limit: limit,
      search_term: filterText?.locationText,
    };
    dispatchGetMasterDataBranch(finalData);
  };

  useDebounce(
    () => {
      if (filterText?.locationText) {
        fetchNewBranchData(filterText?.locationText);
      } else if (filterOffset?.locationOffset > 0) {
        setFilterOffset((prv: any) => ({
          ...prv,
          locationOffset: 0,
        }));
      } else {
        const finalData = {
          token,
          offset: filterOffset?.locationOffset,
          limit: limit,
          search_term: filterText?.locationText,
        };
        dispatchGetMasterDataBranch(finalData);
      }
    },
    500,
    [filterText?.locationText]
  );

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: filterOffset?.recuriterOffset,
        limit: limit,
        user_type: "stco_users",
        status: 1,
        search_term: filterText?.recuriterText,
      };
      if (filterOffset?.recuriterOffset <= finacUser?.total_count) {
        dispatchGetAllFinacUsersAction(finalUserData);
      }
    }
  }, [filterOffset?.recuriterOffset]);

  const fetchNewRecuriterData = (search: string) => {
    const finalData = {
      token,
      offset: filterOffset?.recuriterOffset,
      limit: limit,
      user_type: "stco_users",
      status: 1,
      search_term: filterText?.recuriterText,
    };
    dispatchGetAllFinacUsersAction(finalData);
  };

  useDebounce(
    () => {
      if (filterText?.recuriterText) {
        fetchNewRecuriterData(filterText?.recuriterText);
      } else if (filterOffset?.recuriterOffset > 0) {
        setFilterOffset((prv: any) => ({
          ...prv,
          recuriterOffset: 0,
        }));
      } else {
        const finalData = {
          token,
          offset: filterOffset?.recuriterOffset,
          limit: limit,
          user_type: "stco_users",
          status: 1,
          search_term: filterText?.recuriterText,
        };
        dispatchGetAllFinacUsersAction(finalData);
      }
    },
    500,
    [filterText?.recuriterText]
  );

  // Open Position filter
  useEffect(() => {
    const jobData = openPoisitionList?.map((data: any) => {
      return {
        value: data?._id,
        label: data?.position_name,
      };
    });
    if (
      filterOffset?.openPositionOffset &&
      filterOffset?.openPositionOffset > 0
    ) {
      setFinalJobPositionList([...finalJobPositionList, ...jobData]);
    } else {
      setFinalJobPositionList(jobData);
    }
  }, [openPoisitionList]);
  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: filterOffset?.openPositionOffset,
        limit,
        search_term: filterText?.openPositionText,
        status: 1,
      };
      if (
        filterOffset?.openPositionOffset &&
        filterOffset?.openPositionOffset <= +openPositionTotalCount
      ) {
        dispatchGetRecruitmentModuleOpenPositionAction(finalUserData);
      }
    }
  }, [filterOffset?.openPositionOffset]);

  const fetchNewPositionData = (search: string) => {
    const finalData = {
      token,
      offset: filterOffset?.openPositionOffset,
      limit,
      search_term: filterText?.openPositionText,
      status: 1,
    };
    dispatchGetRecruitmentModuleOpenPositionAction(finalData);
  };

  useDebounce(
    () => {
      if (filterText?.openPositionText) {
        fetchNewPositionData(filterText?.openPositionText);
      } else if (
        filterOffset?.openPositionOffset &&
        filterOffset?.openPositionOffset > 0
      ) {
        setFilterOffset((prv: any) => ({
          ...prv,
          openPositionOffset: 0,
        }));
      } else {
        const finalData = {
          token,
          offset: filterOffset?.openPositionOffset,
          limit,
          search_term: filterText?.openPositionText,
          status: 1,
        };
        dispatchGetRecruitmentModuleOpenPositionAction(finalData);
      }
    },
    500,
    [filterText?.openPositionText]
  );

  useEffect(() => {
    if ((isPersist && isApiCall) || !isPersist) {
      if (token) {
        let finalData = {
          token,
          search_term: searchTerm,
          limit,
          offset,
          sortBy: sortBy?._id,
          sortingOrder: +sortBy?.value,
          progress: filterValue?.progress?.value,
          recruiter: filterValue?.recuriter?.value,
          jobLocation: filterValue?.location?.value,
          openPosition: filterValue?.openPosition?.value,
          gender: filterValue?.gender?.value,
          startDate: filterStartDate
            ? formatDate(filterStartDate)
            : filterStartDate,
          endDate: filterEndDate ? formatDate(filterEndDate) : filterEndDate,
          experience: filterValue?.experience,
        };

        if (recruitmentTrackerTotalCount) {
          if (recruitmentTrackerTotalCount > offset) {
            setIsPersist(false);
            dispatchGetRecruitmentTrackerListAction(finalData);
          }
        } else {
          setIsPersist(false);
          dispatchGetRecruitmentTrackerListAction(finalData);
        }
      }
    }
  }, [offset, isApiCall]);

  useEffect(() => {
    if (!isPersist) {
      if (offset === 0) {
        window.scrollTo(0, 0);
      } else {
        window.scrollTo(0, 0);
        setOffset(0);
      }
    }
  }, [success]);

  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
      const scrollLeft = document.documentElement.scrollLeft;
      setScrollHeights((prev: any) => ({ ...prev, scrollTop, scrollLeft }));

      if (
        offset < +recruitmentTrackerTotalCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (recruitmentTrackerList?.length > 0) {
          if (!fetching && offset < +recruitmentTrackerTotalCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };

  const handleSorting = (data: any) => {
    // if (!isPersist) {
    setIsPersist(false);
    setOffset(0);
    dispatchResetRecruitmentTrackerList();
    setData([]);
    setSortBy(data);

    if (token) {
      let finalData = {
        token,
        search_term: searchTerm,
        limit,
        offset: 0,
        sortBy: data?._id,
        sortingOrder: +data?.value,
        progress: filterValue?.progress?.value,
        recruiter: filterValue?.recuriter?.value,
        jobLocation: filterValue?.location?.value,
        openPosition: filterValue?.openPosition?.value,
        gender: filterValue?.gender?.value,
        startDate: filterStartDate
          ? formatDate(filterStartDate)
          : filterStartDate,
        endDate: filterEndDate ? formatDate(filterEndDate) : filterEndDate,
        experience: filterValue?.experience,
      };

      dispatchGetRecruitmentTrackerListAction(finalData);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [recruitmentTrackerList]);

  useDebounce(
    () => {
      if (searchTerm) {
        fetchNewData();
      } else {
        if (!isPersist) {
          setOffset(0);
        }
      }
    },
    500,
    [searchTerm]
  );

  const fetchNewData = () => {
    if (
      isPersist &&
      searchTerm === persistApplicationInProgressList?.searchTerm
    )
      return;
    dispatchResetRecruitmentTrackerList();
    setData([]);
    setIsPersist(false);
    if (token) {
      let finalData = {
        token,
        search_term: searchTerm,
        limit,
        offset,
        sortBy: sortBy?._id,
        sortingOrder: +sortBy?.value,
        progress: filterValue?.progress?.value,
        recruiter: filterValue?.recuriter?.value,
        gender: filterValue?.gender?.value,
        jobLocation: filterValue?.location?.value,
        openPosition: filterValue?.openPosition?.value,
        startDate: filterStartDate
          ? formatDate(filterStartDate)
          : filterStartDate,
        endDate: filterEndDate ? formatDate(filterEndDate) : filterEndDate,
        experience: filterValue?.experience,
      };
      if (offset === 0) {
        dispatchGetRecruitmentTrackerListAction(finalData);
      } else {
        setOffset(0);
      }
    }
  };

  const handleResetData = () => {
    setIsPersist(false);
    dispatchSetPersistApplicationInProgressData({
      data: [],
      offset: 0,
      scrollLeft: null,
      scrollTop: null,
      searchText: "",
    });
    dispatchResetHrmsSuccess();
    dispatchResetHrmsError();
    dispatchResetHrmsMessage();
    dispatchResetRecruitmentTrackerList();
    dispatchResetRecruitmentTrackerTotalCount();
    dispatchResetHrmsStatusCode();
    if (token) {
      let finalData = {
        token,
        search_term: searchTerm,
        limit,
        offset,
        sortBy: sortBy?._id,
        sortingOrder: +sortBy?.value,
        progress: filterValue?.progress?.value,
        gender: filterValue?.gender?.value,
        recruiter: filterValue?.recuriter?.value,
        jobLocation: filterValue?.location?.value,
        openPosition: filterValue?.openPosition?.value,
        startDate: filterStartDate
          ? formatDate(filterStartDate)
          : filterStartDate,
        endDate: filterEndDate ? formatDate(filterEndDate) : filterEndDate,
        experience: filterValue?.experience,
      };
      if (offset === 0) {
        dispatchGetRecruitmentTrackerListAction(finalData);
      } else {
        setOffset(0);
      }
    }
  };

  const handleApplyFilter = () => {
    setToggleFilterModal(false);
    setIsPersist(false);
    dispatchResetRecruitmentTrackerList();
    if (offset > 0) {
      setOffset(0);
    }
    setData([]);
    setMultiSelectData({
      filterStartDate,
      filterEndDate,
      location: filterValue?.location,
      progress: filterValue?.progress,
      experience: filterValue?.experience,
      recuriter: filterValue?.recuriter,
      gender: filterValue?.gender,
      openPosition: filterValue?.openPosition,
    });

    setFilterOffset({
      locationOffset: 0,
      recuriterOffset: 0,
      openPositionOffset: 0,
    });

    if (token) {
      let finalData = {
        token,
        search_term: searchTerm,
        limit,
        offset: 0,
        sortBy: sortBy?._id,
        sortingOrder: +sortBy?.value,
        progress: filterValue?.progress?.value,
        gender: filterValue?.gender?.value,
        recruiter: filterValue?.recuriter?.value,
        jobLocation: filterValue?.location?.value,
        openPosition: filterValue?.openPosition?.value,
        startDate: filterStartDate
          ? formatDate(filterStartDate)
          : filterStartDate,
        endDate: filterEndDate ? formatDate(filterEndDate) : filterEndDate,
        experience: filterValue?.experience,
      };
      dispatchGetRecruitmentTrackerListAction(finalData);
    }
  };

  const handleSearch = (e: any) => {
    if (isPersist) {
      handleResetData();
    }
    let value = e.target.value;
    setSearchTerm(value);

    if (value?.length === 0 && !isPersist) {
      let finalData = {
        offset: 0,
        limit,
        token,
        sortBy: sortBy?._id,
        sortingOrder: +sortBy?.value,
        progress: filterValue?.progress?.value,
        gender: filterValue?.gender?.value,
        recruiter: filterValue?.recuriter?.value,
        jobLocation: filterValue?.location?.value,
        openPosition: filterValue?.openPosition?.value,
        startDate: filterStartDate
          ? formatDate(filterStartDate)
          : filterStartDate,
        endDate: filterEndDate ? formatDate(filterEndDate) : filterEndDate,
        experience: filterValue?.experience,
      };
      dispatchGetRecruitmentTrackerListAction(finalData);
    }
  };

  const handleEditRecruitmentTracker = (id: string) => {
    dispatchSetPersistApplicationInProgressData({
      data,
      offset,
      ...scrollHeights,
      searchTerm,
    });
    history?.push({
      pathname: `/hrms/recruitment-module/recruitment-tracker/edit`,
      state: {
        id,
        multiSelectData,
        sortBy,
        searchTerm,
        isPersist: true,
      },
    });
  };

  const DeleteOpenRecruitment = (deleteId: string) => {
    if (token && deleteId) {
      const finalData = {
        token,
        id: deleteId,
      };
      dispatchDeleteRecruitmentTrackerAction(finalData);
    }
  };

  const handleFilterClear = () => {
    setToggleFilterModal(false);
    delete history?.location?.state?.multiSelectData;
    dispatchResetRecruitmentTrackerList();
    setData([]);
    if (token) {
      let finalData = {
        token,
        search_term: searchTerm,
        limit,
        offset: 0,
        sortBy: sortBy?._id,
        sortingOrder: +sortBy?.value,
        progress: "",
        recruiter: "",
        jobLocation: "",
        startDate: "",
        endDate: "",
        gender: "",
        openPosition: "",
        experience: null,
      };
      dispatchGetRecruitmentTrackerListAction(finalData);
    }
    setMultiSelectData({
      filterStartDate: "",
      filterEndDate: "",
      location: { name: "", value: "" },
      openPosition: { name: "", value: "" },
      recuriter: { name: "", value: "" },
      progress: { name: "", value: "" },
      gender: { name: "", value: "" },
      experience: null,
    });
  };

  const handleDeleteConfirmationModal = () => {
    setShowDeleteConfirmationModal(!showDeleteConfirmationModal);
  };

  const handleDeleteRecruitmentData = (id: string) => {
    setDeleteId(id);
    setShowDeleteConfirmationModal(true);
  };

  const handleDownload = (params: DownloadRecruitmentTrackerPayloadType) => {
    let reportName = "application_in_progress_report";

    let finalApi = downloadApplicationInProgressExcelApi(params);
    finalApi.then((response: any) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8",
      });
      FileSaver.saveAs(blob, reportName);
      toast.success("Report Downloaded Successfully!", {
        duration: 3000,
      });
    });
  };

  const handlePrepareDownload = () => {
    let params: any = {
      token,
      sortBy: sortBy?._id,
      sortingOrder: sortBy?.value,
      progress: filterValue?.progress?.value,
      recruiter: filterValue?.recuriter?.value,
      jobLocation: filterValue?.location?.value,
      openPosition: filterValue?.openPosition?.value,
      gender: filterValue?.gender?.value,
      startDate: filterStartDate
        ? formatDate(filterStartDate)
        : filterStartDate,
      endDate: filterEndDate ? formatDate(filterEndDate) : filterEndDate,
      experience: filterValue?.experience,
      searchTerm,
    };
    if (params && token) {
      handleDownload(params);
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetHrmsError();
            }}
          />
        );
      }
    }

    if (success === 1 && message?.includes("deleted successfully!")) {
      dispatchResetRecruitmentTrackerList();
      dispatchResetHrmsSuccess();
      dispatchResetHrmsMessage();
      toast.success("Candidate Details has been deleted successfully!", {
        duration: 2000,
      });
      let finalData = {
        token,
        search_term: searchTerm,
        limit,
        offset: 0,
        sortBy: sortBy?._id,
        sortingOrder: +sortBy?.value,
        progress: filterValue?.progress?.value,
        recruiter: filterValue?.recuriter?.value,
        jobLocation: filterValue?.location?.value,
        gender: filterValue?.gender?.value,
        openPosition: filterValue?.openPosition?.value,
        startDate: filterStartDate
          ? formatDate(filterStartDate)
          : filterStartDate,
        endDate: filterEndDate ? formatDate(filterEndDate) : filterEndDate,
        experience: filterValue?.experience,
      };
      if (offset === 0) {
        dispatchGetRecruitmentTrackerListAction(finalData);
      }
    }

    return false;
  };
  return (
    <>
      <div className="">
        <div className="jobs-card">
          <div className="header">
            <div className="left-header d-flex">
              <div>
                <div className="heading mb-0 mt-0">
                  Applications In Progress
                </div>
              </div>
              {
                <div
                  onClick={() => setIsPieChartVisible(!isPieChartVisible)}
                  className="flex-center show-hide-btn-head pl-3"
                >
                  {
                    <div
                      className="show-hide-btn"
                      style={
                        isPieChartVisible
                          ? {
                              border: "1px solid #dd4433",
                              backgroundColor: "#fff6f5",
                            }
                          : { border: "1px solid #262a44" }
                      }
                    >
                      <img
                        src={isPieChartVisible ? analyticsIcon : analyticsGrey}
                        alt=""
                      />
                      <div
                        style={
                          isPieChartVisible
                            ? { color: "#dd4433" }
                            : { color: "#262a44" }
                        }
                      >
                        {isPieChartVisible ? "Hide Summary" : "Open Summary"}
                      </div>
                    </div>
                  }
                </div>
              }
              <div className="flex-center show-hide-btn-head ml-1">
                {
                  <div
                    className="show-hide-btn"
                    style={{
                      color: "#DD4433",
                      border: "1px solid #dd4433",
                    }}
                    onClick={handleResetData}
                  >
                    Refresh
                  </div>
                }
              </div>
            </div>
          </div>
          {isPieChartVisible && (
            <RecruitmentTrackerStageCount
              recruitmentTrackerStageCount={recruitmentTrackerStageCount}
            />
          )}

          <div className="right-header">
            <div
              style={{
                textAlign: "left",
                marginRight: "auto",
                marginLeft: "20px",
              }}
            >
              <div className="sub-heading">{`Total ${
                recruitmentTrackerTotalCount ? recruitmentTrackerTotalCount : 0
              } applications found`}</div>
            </div>
            {isBulkUploadRecruitmentTrackerPresent && (
              <Link
              to={`/hrms/recruitment-module/recruitment-tracker/bulk-upload`}
              className="btn btn-outline-info"
            >
              <i className="fas fa-file-upload"></i>&nbsp;Bulk&nbsp;Upload
            </Link>
            )}
            <div className="col-md-3 position-relative pl-2 pr-2">
              <span style={{ position: "absolute", top: "8px", left: "25px" }}>
                <SearchIcon />
              </span>
              <input
                className="form-control"
                type="text"
                placeholder="Search"
                onChange={(e: any) => handleSearch(e)}
                style={{ paddingLeft: "35px" }}
                value={searchTerm}
              />
            </div>

            <div className="mr-1">
              <RecruitementSorting
                setToggle={setToggle}
                toggle={toggle}
                selectedData={
                  sortBy?.value
                    ? sortBy
                    : { name: "Recently Added/Modified First", value: "" }
                }
                handleSorting={handleSorting}
              />
            </div>

            <div>
              <div className=" mr-3">
                <RecuritmentModuleFilter
                  setToggle={setFilterToggle}
                  toggle={filterToggle}
                  finalUserList={finalUserList}
                  setText={setFilterText}
                  fetching={fetching}
                  filterValue={filterValue}
                  setFilterValue={setFilterValue}
                  setFilterStartDate={setFilterStartDate}
                  setFilterEndDate={setFilterEndDate}
                  filterStartDate={filterStartDate}
                  filterEndDate={filterEndDate}
                  setFilterOffset={setFilterOffset}
                  setFilterText={setFilterText}
                  branchFinalData={branchFinalData}
                  multiSelectData={multiSelectData}
                  limit={limit}
                  handleApplyFilter={handleApplyFilter}
                  handleFilterClear={handleFilterClear}
                  finalJobPositionList={finalJobPositionList}
                  jobPositionFetching={jobPositionFetching}
                  setToggleFilterModal={setToggleFilterModal}
                />
              </div>
            </div>
            {isIsApplicationInProgressDownloadPresent && (
              <div className="pr-2">
                <OverlayTrigger
                  placement="bottom"
                  delay={{ show: 250, hide: 250 }}
                  overlay={
                    <Tooltip id="button-view-download-invoice">
                      Download Reports
                    </Tooltip>
                  }
                >
                  <button
                    className="btn form-control"
                    style={{ border: "1px solid #bfcbe1" }}
                    onClick={() => handlePrepareDownload()}
                  >
                    <img src={NewDownloadIcon} alt="download icon" />
                  </button>
                </OverlayTrigger>
              </div>
            )}
          </div>
          <div>
            {fetching && !toggleFilterModal && offset === 0 ? (
              <TableLoader Rows={10} ColumnPerRow={7} />
            ) : data?.length > 0 ? (
              <RecruitementTrackerTable
                history={history}
                data={data}
                handleEditRecruitmentTracker={handleEditRecruitmentTracker}
                handleDeleteRecruitmentData={handleDeleteRecruitmentData}
                isEditRecruitmentTrackerPresent={
                  isEditRecruitmentTrackerPresent
                }
                isDeleteRecruitmentTrackerPresent={
                  isDeleteRecruitmentTrackerPresent
                }
                activeTab={activeTab}
              />
            ) : (
              <div className="mt-5" style={{ padding: "0px 50px 50px 50px" }}>
                <EmptyListPage
                  title="No Application Found!"
                  image={EmptyList}
                  imageWidth="30%"
                  showLinkButton={false}
                  showAddButton={false}
                />
              </div>
            )}
          </div>
          {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
          <div style={{ display: fetching ? "none" : "inline" }}>
            <ScrollToTop />
          </div>
        </div>
        {showDeleteConfirmationModal && (
          <ConfirmationModal
            toggle={() => {
              handleDeleteConfirmationModal();
            }}
            isOpen={showDeleteConfirmationModal}
            title={`Delete  Candidate Data?`}
            message={`Are you sure you want to Delete?`}
            confirmButtonText="Delete"
            onPressConfirm={() => {
              DeleteOpenRecruitment(deleteId);
              handleDeleteConfirmationModal();
            }}
          />
        )}
        {handleErrorModal()}
      </div>
    </>
  );
};

const mapStateTopProps = (state: RootState) => ({
  token: state.auth.token,
  recruitmentTrackerList: state.hrms.recruitmentTrackerList,
  recruitmentTrackerTotalCount: state.hrms.recruitmentTrackerTotalCount,
  fetching: state.hrms.fetching,
  success: state.hrms.success,
  statusCode: state.hrms.statusCode,
  error: state.hrms.error,
  message: state.hrms.message,
  finacUser: state.auth.finacUsersList,
  masterDataListing: state.masterData.masterDataListing,
  masterDataBranchListTotal: state.masterData.masterDataBranchListTotal,
  branchMessage: state.masterData.branchMessage,
  branchFetching: state.masterData.branchFetching,
  persistApplicationInProgressList:
    state.masterData.persistApplicationInProgress,
  openPoisitionList: state.hrms.openPoisitionList,
  openPositionTotalCount: state.hrms.openPositionTotalCount,
  jobPositionFetching: state.hrms.fetching,
  recruitmentTrackerStageCount: state.hrms.recruitmentTrackerStageCount,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetHrmsSuccess: () => dispatch(resetHrmsSuccess()),
  dispatchResetHrmsMessage: () => dispatch(resetHrmsMessage()),
  dispatchResetHrmsError: () => dispatch(resetHrmsError()),
  dispatchResetHrmsStatusCode: () => dispatch(resetHrmsStatusCode()),
  dispatchResetRecruitmentTrackerList: () =>
    dispatch(resetRecruitmentTrackerList()),
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacUsersAction(data)),
  dispatchGetMasterDataBranch: (data: GetAllMasterDataBranchPayloadType) => {
    dispatch(getAllMasterDataBranchAction(data));
  },
  //
  dispatchResetRecruitmentTrackerTotalCount: () =>
    dispatch(resetRecruitmentTrackerTotalCount()),
  //
  dispatchGetRecruitmentTrackerListAction: (
    data: GetRecruitmentTrackerPayloadType
  ) => dispatch(getRecruitmentTrackerListAction(data)),
  dispatchDeleteRecruitmentTrackerAction: (
    data: DeleteOpenPositionPayloadType
  ) => dispatch(deleteRecruitmentTrackerAction(data)),
  dispatchResetMasterDataListing: () => dispatch(resetMasterDataLisitng()),
  dispatchResetBranchStatusCode: () => dispatch(resetBranchSatusCode()),
  dispatchResetBranchError: () => dispatch(resetBranchError()),
  dispatchResetBranchMessage: () => dispatch(resetBranchMessage()),
  dispatchResetBranchFetching: () => dispatch(resetBranchFetching()),
  dispatchSetPersistApplicationInProgressData: (data: any) =>
    dispatch(setPersistApplicationInProgess(data)),
  dispatchGetRecruitmentModuleOpenPositionAction: (
    data: GetOpenPositionPayloadType
  ) => dispatch(getRecruitmentModuleOpenPositionAction(data)),
  dispatchResetRecruitmentTrackerStageCountList: () =>
    dispatch(resetRecruitmentTrackerStageCountList()),
});

export default connect(
  mapStateTopProps,
  mapDispatchToProps
)(ApplicationInProgressList);
